/*eslint-disable*/
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Loader, TableSizeControls, TableTabsWrapper } from 'ui-kit';
import { isValidDate } from 'utils/old/checkSearchDate';
import ITEMS_PER_PAGE_OPTIONS from '_constants/old/_constants/ITEMS_PER_PAGE_OPTIONS';
import qsSearchApplyUtil from 'utils/old/qsSearchApplyUtil';
import constant from '_constants/old/_constants/index';
import { BUTTON_TYPES } from '_constants';
import ButtonOrganizer from 'ui-kit/old/buttonOrganizer';
import AttentionModal from 'ui-kit/Modal/old/Attention/index';
import AuditLogsTable from 'modules/AuditLogsTable';
import AccountTime from 'modules/AccountTime';
import { notification } from 'utils/services';
import processQSParams from 'utils/old/processQSParams';
import Filter from 'ui-kit/old/filter';
import { auditRevert } from '_entities/Audit/Audit.services';
import { setIsNotification } from '_entities/old/Retailers/retailers.action';
import DEFAULT_SORT from '_constants/old/_constants/DEFAULT_SORT';
import { AuditEntity, AuthEntity, FilterEntity } from '_entities';
import * as Styled from './styles';

const {
  BUTTON_STYLES: { ACCEPT_AUDIT, CANCEL_MODAL, ACCEPT_MODAL },
} = constant;

const { applyFilters } = FilterEntity.actions;
const { getAuditTableData } = AuditEntity.selectors;
const { getTimeZone } = AuthEntity.selectors;
const { setIdRevert, getAuditList } = AuditEntity.actions;

const AuditLogsComponent = ({
  objectType,
  recordId,
  showSearch = true,
  tableComponent: AuditTable = AuditLogsTable,
  searchInToolbar = false,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [currentPerPage, setCurrentPerPage] = useState(ITEMS_PER_PAGE_OPTIONS[1].value);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOption, setSortOption] = useState({
    sortBy: DEFAULT_SORT.audits.prop,
    sortOrder: DEFAULT_SORT.audits.order,
  });
  const [loading, setLoading] = useState(false);
  const [showModalRestoreRecord, setShowModalRestoreRecord] = useState(false);
  const [showModalAttention, setShowModalAttention] = useState(false);

  const { data, pagination } = useSelector(getAuditTableData);
  const timeZone = useSelector(getTimeZone);
  const idRevert = useSelector((state) => state.audit?.idRevert);

  const {
    oldFilter: { generalFilters },
  } = useSelector((state) => state);

  const dispatch = useDispatch();
  const history = useHistory();

  const content = `The retailer was deleted. To restore ${
    idRevert?.objType || 'record'
  }, you should restore retailer first.`;
  const contentDeleted = 'Are you sure you want to restore this record?';

  const loadAuditLogs = useCallback(
    async ({
      page = currentPage,
      perPage = currentPerPage,
      sortBy = sortOption.sortBy,
      sortOrder = sortOption.sortOrder,
      filters = {},
      ...rest
    } = {}) => {
      try {
        setLoading(true);
        const baseFilters = {
          ...(objectType ? { object_type: objectType } : {}),
          ...(recordId ? { record_id: recordId } : {}),
        };
        const params = processQSParams({
          ...baseFilters,
          ...filters,
          ...rest,
          page,
          perPage,
          sortOrder,
          sortBy,
        });
        await dispatch(getAuditList(params, timeZone));
      } catch (e) {
        console.log('e', e);
      } finally {
        setLoading(false);
      }
    },
    [currentPage, dispatch, currentPerPage, sortOption, objectType, recordId, timeZone],
  );

  const sortHandler = useCallback(
    (sortBy, sortOrder) => {
      setSortOption({ sortBy, sortOrder });
      loadAuditLogs({ sortBy, sortOrder });
    },
    [loadAuditLogs],
  );

  const handlePageChange = useCallback(
    ({ value }) => {
      setCurrentPage(value);
      loadAuditLogs({ page: value });
    },
    [loadAuditLogs],
  );

  const handlePerPageChange = useCallback(
    ({ value }) => {
      if (currentPerPage === value) return;
      setCurrentPerPage(value);
      setCurrentPage(1);
      loadAuditLogs({ perPage: value, page: 1 });
    },
    [currentPerPage, loadAuditLogs],
  );

  useEffect(() => {
    loadAuditLogs();
  }, []);

  const handleRemoveSearch = () => {
    if (isEmpty(searchValue)) return;
    qsSearchApplyUtil({
      dispatch,
      getApi: loadAuditLogs,
      generalFilters: {},
    });
    setSearchValue('');
  };

  const handleOnChangeInputSearch = (searchVal) => {
    const trimmedVal = searchVal;
    if (isEmpty(trimmedVal)) {
      qsSearchApplyUtil({
        dispatch,
        getApi: loadAuditLogs,
        generalFilters: {},
      });
    }
    setSearchValue(decodeURI(encodeURI(trimmedVal)));
  };

  const handleClickInput = () => {
    if (isEmpty(searchValue)) return;
    const searchString = isValidDate(searchValue);
    qsSearchApplyUtil({
      search: searchString,
      dispatch,
      getApi: loadAuditLogs,
      generalFilters: {},
    });
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      const searchString = isValidDate(searchValue);
      qsSearchApplyUtil({
        search: searchString,
        dispatch,
        getApi: loadAuditLogs,
        generalFilters: {},
      });
    }
  };

  const setFocus = () => {
    document.getElementById('firstColumn')?.focus();
  };

  const buttons = (
    <ButtonOrganizer
      buttons={[
        {
          type: CANCEL_MODAL,
          id: 'CancelModal',
          text: 'Cancel',
          variant: BUTTON_TYPES.DARK,
          onClick: () => {
            setShowModalAttention(false);
          },
          children: 'Cancel',
          style: { marginTop: '40px', marginRight: '10px', width: '132px' },
        },
        {
          type: ACCEPT_AUDIT,
          id: 'AcceptAudit',
          text: 'Restore retailer',
          variant: BUTTON_TYPES.DANGER,
          onClick: async () => {
            try {
              setShowModalAttention(false);
              dispatch(setIsNotification(true));
              await auditRevert(dispatch, idRevert.idRec, setFocus, (elem) => notification.success(elem));
              await loadAuditLogs();
            } catch (e) {
              console.log(e);
            }
          },
          children: 'Restore retailer',
          style: { marginTop: '40px', width: '132px' },
        },
      ]}
    />
  );

  const buttonsRestore = (
    <ButtonOrganizer
      buttons={[
        {
          type: CANCEL_MODAL,
          id: 'CancelModal',
          text: 'Cancel',
          variant: BUTTON_TYPES.DARK,
          onClick: () => {
            setShowModalRestoreRecord(false);
          },
          children: 'Cancel',
          style: { marginTop: '40px', marginRight: '10px', width: '132px' },
        },
        {
          type: ACCEPT_MODAL,
          id: 'AcceptAudit',
          text: 'Yes',
          variant: BUTTON_TYPES.DANGER,
          onClick: async () => {
            try {
              setShowModalRestoreRecord(false);
              await auditRevert(dispatch, idRevert.idRec, setFocus, () =>
                notification.success(`The record ${idRevert.idRec} was successfully restored!`),
              );
              await loadAuditLogs();
            } catch (e) {
              console.log(e);
            }
          },
          children: 'Yes',
          style: { marginTop: '40px', width: '132px' },
        },
      ]}
    />
  );

  /* The search box, in the new design's skin. Rendered into the table's own toolbar when the caller
     asks for it (searchInToolbar) so it sits in the table header like every other new-UI list,
     otherwise above the table exactly as before. */
  const searchField = (
    <Filter
      type="button"
      placeholder="Search audit log "
      onChangeInput={handleOnChangeInputSearch}
      handleClickInput={handleClickInput}
      onKeyDown={handleKeyDown}
      onRemoveSearch={handleRemoveSearch}
      searchValue={searchValue}
      hideFilterBtn
      isWidth
    />
  );

  const tableToolbar = searchInToolbar
    ? {
        left: showSearch ? <Styled.ToolbarSearchWrap>{searchField}</Styled.ToolbarSearchWrap> : null,
        // Right of the sort control: <ListTable /> puts sort + column picker in `lead`, and
        // DataTable's toolbar renders {lead}{actions}, so this lands at the end of that row.
        actions: <Styled.Count>{pagination?.count || 0} items</Styled.Count>,
        bottom: timeZone ? (
          <Styled.TimezoneNotice>
            <span>All timestamps are displayed in account timezone {timeZone}:</span>
            <AccountTime />
          </Styled.TimezoneNotice>
        ) : null,
      }
    : null;

  const handleAuditAction = useCallback(
    ({ deleted, recordId, objectType, itemId }) => {
      if (deleted) {
        setShowModalAttention(true);
      } else {
        setShowModalRestoreRecord(true);
      }
      dispatch(
        setIdRevert({
          id: recordId,
          objType: objectType,
          idRec: deleted ? deleted.audit_log_id : itemId,
        }),
      );
    },
    [dispatch],
  );

  return (
    <Styled.AuiditTabWrapper>
      {loading && <Loader />}
      {showModalAttention && (
        <AttentionModal
          typeContent="text"
          buttons={buttons}
          viewComponent={content}
          isShowModal={() => setShowModalAttention(false)}
          type="closeRetailer"
        />
      )}
      {showModalRestoreRecord && (
        <AttentionModal
          typeContent="text"
          buttons={buttonsRestore}
          viewComponent={contentDeleted}
          isShowModal={() => setShowModalRestoreRecord(false)}
          type="closeRetailer"
        />
      )}

      <Styled.Wrapper>
        {showSearch && !searchInToolbar && <Styled.FilterWrapper>{searchField}</Styled.FilterWrapper>}
        {timeZone && !searchInToolbar && (
          <Styled.TimezoneNotice>
            <span>All timestamps are displayed in account timezone {timeZone}:</span>
            <AccountTime />
          </Styled.TimezoneNotice>
        )}
        {/* The count moved into the table's own toolbar above, so this strip -- a bordered box that
            held nothing else here -- is dropped in the new design. */}
        <TableTabsWrapper
          isHidden={searchInToolbar}
          amount={pagination?.count || 0}
          tableComponent={
            <Styled.TableContainer>
              {/* Pagination goes THROUGH the table rather than beside it, the way the retailers
                  table does. The new-design table then renders it inside its card, so it picks up
                  the card's background and its rounded bottom corners -- as a sibling it sat on the
                  page background instead, and the card's bottom edge was the last row, which is
                  what rounded the final cell. The legacy table renders it in the same place as
                  before, so the old design is untouched. */}
              <AuditTable
                data={data}
                sortOption={sortOption}
                sortHandler={sortHandler}
                handleAuditAction={handleAuditAction}
                isShortVersion
                toolbar={tableToolbar}
                footer={
                  <TableSizeControls
                    itemsPerPageProps={{
                      handlePerPageChange,
                      value: currentPerPage,
                    }}
                    pageCountProps={{
                      value: currentPage,
                      pages: pagination?.pages || 1,
                      handlePageChange,
                    }}
                    paginationInfoProps={{
                      total: pagination?.count || 0,
                      currentPage,
                      perPage: currentPerPage,
                    }}
                    paginationNavProps={{
                      currentPage,
                      handlePageChange,
                      pages: pagination?.pages || 1,
                      titleTable: 'Audit Log',
                    }}
                  />
                }
              />
            </Styled.TableContainer>
          }
        />
      </Styled.Wrapper>
    </Styled.AuiditTabWrapper>
  );
};

AuditLogsComponent.propTypes = {
  objectType: PropTypes.string,
  recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showSearch: PropTypes.bool,
  /* The table to render. Defaults to the legacy grid; the new design passes AuditLogsTableNew.
     A prop rather than a useNewUi() check in here so this shared component keeps its module graph
     — importing the new table pulls modules/ListTable, which trips the assets/styles circular
     import in some consumers' test environments. */
  tableComponent: PropTypes.elementType,
  /* Put the search + timezone note in the table's header row instead of above the table. Set by
     the new design, whose table can host them. */
  searchInToolbar: PropTypes.bool,
};

export default AuditLogsComponent;
